import { render, staticRenderFns } from "./GlassCard.vue?vue&type=template&id=55ecda0a&scoped=true"
import script from "./GlassCard.vue?vue&type=script&lang=js"
export * from "./GlassCard.vue?vue&type=script&lang=js"
import style0 from "./GlassCard.vue?vue&type=style&index=0&id=55ecda0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ecda0a",
  null
  
)

export default component.exports